import type {ComponentProps} from 'react';
import {classNames} from 'utils';

interface ISliderProps extends ComponentProps<'input'> {
  onSlide: (value: number) => void;
}

const Slider = ({onSlide, ...props}: ISliderProps) => {
  const value = props.value as number;
  const min = (props.min as number) ?? 0;
  const max = (props.max as number) ?? 100;
  const fill = ((Math.min(Math.max(value, min), max) - min) / (max - min)) * 100;
  return (
    <input
      {...props}
      type="range"
      onChange={e => onSlide(+e.target.value)}
      className={classNames(
        'w-full h-2 rounded-lg bg-slate-300 dark:bg-slate-600 appearance-none cursor-grab active:cursor-grabbing',
        '[&::-webkit-slider-thumb]:appearance-none',
        '[&::-webkit-slider-thumb]:w-4 [&::-webkit-slider-thumb]:h-4',
        '[&::-webkit-slider-thumb]:rounded-full',
        '[&::-webkit-slider-thumb]:bg-primary',
      )}
      style={{
        backgroundImage: 'linear-gradient(#34bc78)',
        backgroundRepeat: 'no-repeat',
        backgroundSize: `${fill}% 100%`,
      }}
    />
  );
};

export default Slider;
